import { atom } from "jotai";

import { VerifyEmailOrPhoneStepState } from "./types";

export const defaultVerifyEmailOrPhoneStepState: VerifyEmailOrPhoneStepState = {
  step: "Initial",
  backStep: null,
};

export const VerifyEmailOrPhoneStepStateAtom =
  atom<VerifyEmailOrPhoneStepState>(defaultVerifyEmailOrPhoneStepState);

export const VerifyEmailOrPhoneCloseActionAtom = atom<(() => void) | null>(
  null
);

export const isVerifyingEmailOrPhoneAtom = atom<"email" | "phone" | null>(null);

export const shouldCloseOnBackPressAtom = atom((get) => {
  const state = get(VerifyEmailOrPhoneStepStateAtom);
  return state.backStep === null;
});
